import React from 'react';

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardText from "components/Card/CardText.jsx";
import { Link } from 'react-router-dom';

import {
    cardTitle
} from "assets/jss/material-dashboard-pro-react.jsx";
import AccountImage from '../../../components/Image/AccountImage';
import UserImage from '../../../components/Image/UserImage';
import moment from 'moment';
import { Tooltip } from '@material-ui/core';
import FileBlock from '../../../components/Files/FileBlock';
import Api from '../../../api/Api.js';
import FileEndpoints from '../../../api/FileEndpoints';
import FileDownloadHelper from '../../../helpers/FileDownloadHelper';

class NoteStandalone extends React.Component {
    render() {

        const { classes } = this.props;

        var { account } = this.props;
        if (!account && this.props.reply_to) {
            account = this.props.reply_to.account;
        }

        var mainColor = "primary";

        if (this.props.reply_to) {
            mainColor = "info";
        }

        return (
            <Card>
                <CardHeader color={mainColor} text>
                    {
                        !account ?
                            (
                                <CardText color={mainColor} style={{ width: '100%' }}>
                                    Note not linked to a customer
                                </CardText>
                            )
                            :
                            (
                                <Link to={`/customers/view/${account.id}`}>
                                    <CardText color={mainColor} style={{ width: '100%' }}>
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', paddingRight: 20 }}>
                                                <AccountImage {...account} />
                                            </div>
                                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                                                <h4 style={{
                                                    ...{
                                                        ...cardTitle,
                                                        color: "#FFFFFF",
                                                        marginTop: "0"
                                                    }
                                                }}>{account.account_no}</h4>
                                                <h4 style={{
                                                    ...{
                                                        margin: "0",
                                                        color: "rgba(255, 255, 255, 0.8)",
                                                        fontSize: ".875rem"
                                                    }
                                                }}>
                                                    {account.name}
                                                </h4>
                                            </div>
                                        </div>
                                    </CardText>
                                </Link>
                            )
                    }
                </CardHeader>
                <CardBody className={classes.commentContent}>
                    <Link to={(!account ? '#' : `/customers/view/${account.id}/0/${this.props.reply_to ? this.props.reply_to.id : this.props.id}`)} style={{ color: 'initial' }}>
                        {
                            this.props.reply_to ?
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', borderBottom: this.props.reply_to.uploads && this.props.reply_to.uploads.length > 0 ? 'none' : '1px solid rgba(0, 0, 0, 0.12)', marginBottom: 10, paddingBottom: 10 }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', paddingRight: 20 }}>
                                        <Tooltip
                                            id="tooltip-top-start"
                                            title={this.props.reply_to.user.name + (this.props.reply_to.user.surname ? " " + this.props.reply_to.user.surname : "")}
                                            placement="top"
                                            classes={{ tooltip: classes.tooltip }}
                                        >
                                            <UserImage {...this.props.reply_to.user} />
                                        </Tooltip>
                                    </div>
                                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                                        <h5 style={{ whiteSpace: 'pre-wrap' }}>{this.props.reply_to.message}</h5>
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center', paddingLeft: 20 }}>
                                        <strong>{moment(this.props.reply_to.when).format("D MMMM YYYY @ HH:mm")}</strong>
                                    </div>
                                </div>
                                :
                                null
                        }
                        {
                            this.props.reply_to && this.props.reply_to.uploads && this.props.reply_to.uploads.length > 0 ?
                                [
                                    <div key="files" style={{ margin: 10, padding: 5, boxShadow: 'inset 0px 0px 28px -8px rgba(0,0,0,0.75)', backgroundColor: '#f7f7f7', borderRadius: 5, display: 'flex', flexWrap: 'wrap', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'space-evenly', alignContent: 'space-around' }}>
                                        {
                                            this.props.reply_to.uploads.map(file => {
                                                return (
                                                    <FileBlock
                                                        key={file.id}
                                                        shared={file.shared}
                                                        fileType={file.original_name.split('.').pop().toLowerCase()}
                                                        fileName={file.original_name}
                                                        image={
                                                            file.original_name.split('.').pop().toLowerCase() === 'jpg'
                                                                ||
                                                                file.original_name.split('.').pop().toLowerCase() === 'jpeg'
                                                                ||
                                                                file.original_name.split('.').pop().toLowerCase() === 'png' ?
                                                                "/api/shared/file?id=" + file.id : null
                                                        }
                                                        onClick={e => Api.fileDownload(FileEndpoints.download, file).then(({ data }) => FileDownloadHelper(data, file.mimeType, file.original_name))}
                                                    />
                                                );
                                            })
                                        }
                                    </div>,
                                    <div key="divider" style={{ marginBottom: 10, borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }} />
                                ]
                                :
                                null
                        }
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', paddingLeft: (this.props.reply_to ? 40 : 0) }}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', paddingRight: 20 }}>
                                <Tooltip
                                    id="tooltip-top-start"
                                    title={this.props.user.name + (this.props.user.surname ? " " + this.props.user.surname : "")}
                                    placement="top"
                                    classes={{ tooltip: classes.tooltip }}
                                >
                                    <UserImage {...this.props.user} />
                                </Tooltip>
                            </div>
                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                                <h5 style={{ whiteSpace: 'pre-wrap' }}>{this.props.message}</h5>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center', paddingLeft: 20 }}>
                                <strong>{moment(this.props.when).format("D MMMM YYYY @ HH:mm")}</strong>
                            </div>
                        </div>
                        {
                            this.props.uploads && this.props.uploads.length > 0 ?
                                <div style={{ margin: 10, padding: 5, boxShadow: 'inset 0px 0px 28px -8px rgba(0,0,0,0.75)', backgroundColor: '#f7f7f7', borderRadius: 5, display: 'flex', flexWrap: 'wrap', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'space-evenly', alignContent: 'space-around' }}>
                                    {
                                        this.props.uploads.map(file => {
                                            return (
                                                <FileBlock
                                                    key={file.id}
                                                    shared={file.shared}
                                                    fileType={file.original_name.split('.').pop().toLowerCase()}
                                                    fileName={file.original_name}
                                                    image={
                                                        file.original_name.split('.').pop().toLowerCase() === 'jpg'
                                                            ||
                                                            file.original_name.split('.').pop().toLowerCase() === 'jpeg'
                                                            ||
                                                            file.original_name.split('.').pop().toLowerCase() === 'png' ?
                                                            "/api/shared/file?id=" + file.id : null
                                                    }
                                                    onClick={e => Api.fileDownload(FileEndpoints.download, file).then(({ data }) => FileDownloadHelper(data, file.mimeType, file.original_name))}
                                                />
                                            );
                                        })
                                    }
                                </div>
                                :
                                null
                        }
                    </Link>
                </CardBody>
            </Card>
        );
    }
}
//export NoteStandalone;
export default (props) => (props.notes.length ? props.notes.map(x => <NoteStandalone key={x.id} {...x} classes={props.classes} />) : null);
